import { IConfigState } from './types';

const getters = {
  accessConfig: (state: IConfigState) => state.accessConfig.data,
  organizationConfig: (state: IConfigState) => state.organizationConfig.data,
  testFlow: (state: IConfigState) => state.testFlow.data,
  linkInfo: (state: IConfigState) => state.linkInfo.data,
  locale: (state: IConfigState) => state.locale.data,
  dynamicConfig: (state: IConfigState) => state.dynamicConfig.data,
  cookiePolicyUrl: (state: IConfigState) => {
    const lang = state.linkInfo?.data?.payload?.lang;
    const cookiePolicy = state.requiredRegistrationProperties?.data?.documents?.cookiePolicy;
    const cookiePolicyOfCurrentLanguage = lang && cookiePolicy?.[lang]?.cookiePolicyUrl;

    return cookiePolicyOfCurrentLanguage || cookiePolicy?.cookiePolicyUrl;
  },
  termsOfUseUrl: (state: IConfigState) => {
    const lang = state.linkInfo?.data?.payload?.lang;
    const termsOfUse = state.requiredRegistrationProperties?.data?.documents?.termsOfUse;
    const termsOfUseCurrentLanguage = lang && termsOfUse?.[lang]?.termsOfUseUrl;

    return termsOfUseCurrentLanguage || termsOfUse?.termsOfUseUrl;
  },
  termsOfUseVersion: (state: IConfigState) => {
    const termsOfUse = state.requiredRegistrationProperties?.data?.documents?.termsOfUse;

    return termsOfUse?.version;
  },
  manifest: (state: IConfigState) => state.manifest?.data,
  urlParams: (state: IConfigState) => {
    const lang = state.linkInfo.data?.payload.lang;
    const direction = lang === 'he' ? 'rtl' : 'ltr';
    const linkInfoProps = {
      testFlowId: state.linkInfo.data?.payload.testFlowId,
      offeringName: state.linkInfo.data?.payload.offeringName,
      accessConfigName: state.linkInfo.data?.payload.manifestPath,
      lang,
      direction,
      initialValues: state.linkInfo.data?.payload.initialValues || {},
      baseConfigUrl: state.linkInfo.data?.payload.baseConfigURL,
      basePath: state.linkInfo.data?.manifest.basePath,
    };

    return { ...state.urlState, ...linkInfoProps };
  },
};

export default getters;
